import React from 'react';
import { Users, Radio, Star } from 'lucide-react';

/**
 * UpdatedStatistics Component
 * إحصائيات الإذاعة
 * Radio Statistics
 */
const UpdatedStatistics = () => {
  const statsCards = [
    {
      titleAr: 'مستمع شهرياً',
      value: '+5000',
      icon: Users,
      color: 'from-gold to-gold-light',
    },
    {
      titleAr: 'برنامج',
      value: '12',
      icon: Radio,
      color: 'from-gold to-gold-light',
    },
    {
      titleAr: 'فريق عمل',
      value: '20',
      icon: Users,
      color: 'from-gold to-gold-light',
    },
    {
      titleAr: 'تقييم المستمعين',
      value: '4.8',
      icon: Star,
      color: 'from-gold to-gold-light',
    }
  ];

  return (
    <section className="relative py-20 overflow-hidden">
      {/* صورة الخلفية */}
      <img
        src={require('../assest/New folder/4567.jpg')}
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      
      {/* تدرج داكن فوق الخلفية */}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/90 via-primary-dark/85 to-primary/90"></div>

      {/* المحتوى */}
      <div className="container mx-auto px-4 relative z-10">
        {/* عنوان القسم */}
        <div className="text-center mb-16">
          <div className="inline-block">
            <h2 className="text-5xl font-bold text-white mb-4">
            </h2>
            {/* <div className="h-1 bg-gradient-to-r from-transparent via-gold to-transparent"></div> */}
          </div>
        </div>

        {/* بطاقات الإحصائيات */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {statsCards.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="text-center transform hover:scale-110 transition-all duration-300"
                style={{ animation: `fade-in 0.6s ease-out ${index * 0.1}s backwards` }}
              >
                <div className={`w-20 h-20 md:w-24 md:h-24 rounded-full bg-gradient-to-br ${stat.color} flex items-center justify-center mb-4 shadow-2xl mx-auto`}>
                  <Icon className="w-10 h-10 md:w-12 md:h-12 text-white" />
                </div>
                <div className="text-4xl md:text-5xl font-bold text-white mb-2 drop-shadow-lg">
                  {stat.value}
                </div>
                <div className="text-gold text-base md:text-lg font-semibold">
                  {stat.titleAr}
                </div>
              </div>
            );
          })}
        </div>

        {/* الأمواج الصوتية */}
        {/* <div className="bg-white/10 backdrop-blur-md rounded-3xl p-12 border-2 border-gold/30 shadow-2xl">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-white mb-2">
              موجات البث المباشر
            </h3>
            <p className="text-gray-300">
              تصور مباشر للموجات الصوتية
            </p>
          </div>

       
          <SimpleWaveform />

       
          <div className="flex items-center justify-center gap-3 mt-8">
            <span className="relative flex h-4 w-4">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-600 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-4 w-4 bg-red-600"></span>
            </span>
            <span className="text-white font-bold text-xl">
              البث مباشر الآن
            </span>
          </div>
        </div> */}

        {/* آخر ما تم الاستماع إليه */}
        {/* {recentlyPlayed && recentlyPlayed.length > 0 && (
          <div className="mt-16">
            <h3 className="text-3xl font-bold text-white mb-8 text-center">
              آخر ما تم الاستماع إليه
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {recentlyPlayed.slice(0, 6).map((item, index) => (
                <div
                  key={index}
                  className="bg-white/10 backdrop-blur-md rounded-xl p-6 border border-white/20 hover:border-gold/50 transition-all duration-300 transform hover:scale-105"
                  style={{ animation: `fade-in 0.6s ease-out ${index * 0.1}s backwards` }}
                >
                  <div className="flex items-start gap-4">
                    {item.track.cover && (
                      <img
                        src={item.track.cover}
                        alt={item.track.title}
                        className="w-20 h-20 rounded-lg object-cover shadow-lg"
                      />
                    )}
                    <div className="flex-1">
                      <h4 className="text-white font-bold text-lg mb-1 line-clamp-1">
                        {item.track.title}
                      </h4>
                      <p className="text-gray-300 text-sm mb-2 line-clamp-1">
                        {item.track.artist}
                      </p>
                      <p className="text-gray-400 text-xs">
                        {new Date(item.playedAt).toLocaleDateString('ar-AE', {
                          month: 'short',
                          day: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )} */}
      </div>
    </section>
  );
};

export default UpdatedStatistics;
